module.exports = __webpack_public_path__ + "img/zhyj-3.6ed60f17.png";